export * from './constants';
export * from './UserRightsArray';
export const defaultPageSize = 30;
export const dateFormat = "Do MMM, YYYY"
export const uriRoot = "/admin";
export const defaultTZ = "Canada/Mountain";